import App from '@/app/App';
import '@/lib/telemetry';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />,
  </StrictMode>,
);
